const japaneseAnnouncement = {
  dateLabel: "日付",
  titleLabel: "タイトル",
  bodyLabel: "本文",
  title: "新機能のお知らせ",
  body: [
    "新機能1：論文全文分析機能が図表等に対応し、同時分析可能論文数を拡大",
    "MediLensは、Abstractだけでなく、本文・表・図・グラフまで読み込み、ユーザーの質問に合わせて情報を抽出できるようになりました。",
    "また、分析できる論文数は最低選択数の制限なく、最大60報まで利用できます。",
    "これにより、従来よりも以下のような深い確認が可能になります。",
    "・Tableにある群別データやカットオフ値を整理する\n・図やグラフから主要な傾向を把握する\n・試験設計、評価項目、解析方法の根拠を確認する\n・直接回答が見つからない場合でも、関連論文から次の探索方針を見つける",
    "注意：消費検索回数（=クレジット数）",
    "当機能は通常検索よりも多くの論文情報を読み込むため、利用量に応じてクレジットを消費します。",
    "目安として論文1本に対する1回の質問につき、約1クレジットとなります。",
    "尚、通常検索のクレジット体系は変更ありません。\nベーシック検索：1クレジット/回\nプロ検索：2クレジット/回",
    "より重要な論文を深く確認したい場合や、Abstractだけでは判断できない情報を確認したい場合に、是非全文分析をご活用ください。",
    "新機能2：最新順・引用数順ソート",
    "論文検索結果を従来はマッチ度でのみ提示しておりましたが、この度発表年の新しい順および引用数順にソートする機能を追加致しました。",
    "最新の研究動向を把握するなどの場合に、是非お役立てできると幸いです。",
  ],
  confirmLabel: "確認しました",
};

const chineseAnnouncement = {
  dateLabel: "日期",
  titleLabel: "标题",
  bodyLabel: "正文",
  title: "新功能公告",
  body: [
    "新功能 1：论文全文分析功能现已支持图表等内容，并扩大可同时分析的论文数量",
    "MediLens 现在不仅可以读取 Abstract，还可以读取正文、表格、图片和图表，并根据用户的问题提取相关信息。",
    "同时，论文分析没有最低选择数量限制，最多可分析 60 篇论文。",
    "因此，现在可以进行比以往更深入的确认，例如：",
    "・整理 Table 中的分组数据和 cutoff 值\n・从图片和图表中把握主要趋势\n・确认试验设计、评价指标和分析方法的依据\n・即使没有找到直接答案，也可以从相关文章中找到下一步探索方向",
    "注意：消耗的搜索次数（= credit 数）",
    "由于该功能会读取比普通搜索更多的论文信息，因此会根据使用量消耗 credit。",
    "作为参考，对 1 篇论文进行 1 次提问约消耗 1 credit。",
    "普通搜索的 credit 体系没有变化。\nBasic 搜索：1 credit/次\nPro 搜索：2 credits/次",
    "当您希望深入确认重要论文，或需要确认 Abstract 无法判断的信息时，欢迎使用全文分析功能。",
    "新功能 2：按最新顺序和引用数排序",
    "此前论文搜索结果仅按匹配度展示。本次新增了按发表年份从新到旧排序，以及按引用数排序的功能。",
    "希望该功能能帮助您把握最新研究动向。",
  ],
  confirmLabel: "我已确认",
};

const englishAnnouncement = {
  dateLabel: "Date",
  titleLabel: "Title",
  bodyLabel: "Body",
  title: "New Feature Announcement",
  body: [
    "New feature 1: Full-text paper analysis now supports figures and tables, with an expanded number of papers for simultaneous analysis",
    "MediLens can now read not only abstracts, but also the main text, tables, figures, and graphs, and extract information according to the user's question.",
    "Paper analysis now has no minimum source requirement and supports up to 60 papers.",
    "This enables deeper checks than before, such as:",
    "・Organizing group-level data and cutoff values from tables\n・Understanding major trends from figures and graphs\n・Checking the rationale behind study design, endpoints, and analysis methods\n・Finding the next exploration direction from related papers even when no direct answer is available",
    "Note: Search usage consumed (= credits)",
    "Because this feature reads more paper information than regular search, it consumes credits according to usage.",
    "As a guide, one question for one paper consumes about 1 credit.",
    "The credit system for regular search has not changed.\nBasic search: 1 credit/search\nPro search: 2 credits/search",
    "Please use full-text analysis when you want to examine important papers more deeply or verify information that cannot be judged from the abstract alone.",
    "New feature 2: Sort by newest and by citation count",
    "Previously, paper search results were shown only by match score. We have now added sorting by newest publication year and by citation count.",
    "We hope this helps you understand the latest research trends.",
  ],
  confirmLabel: "I understand",
};

const releaseAnnouncement = {
  id: "2026-06-08-paper-analysis-sorting-update",
  publishedAt: "2026/6/8",
  translations: {
    ja: japaneseAnnouncement,
    zh: chineseAnnouncement,
    en: englishAnnouncement,
  },
};

export default releaseAnnouncement;
